<div class="d-flex gap-2">
  <button mat-mini-fab [matMenuTriggerFor]="transparency" aria-label="Trasparena" color="">
    <mat-icon>settings</mat-icon>
  </button>

  <mat-menu #transparency="matMenu" yPosition="above" (click)="$event.stopPropagation();">
    <div class="settings-overlay">
      <div class="slider">
        <mat-icon>tonality</mat-icon>
        <mat-slider
          min="0"
          max="1"
          step="0.1"
        >
          <input
            matSliderThumb
            [value]="layerOpacity"
            (valueChange)="onOpacityLayerChange($event)"
          />
        </mat-slider>
      </div>

      <div class="slider" *ngIf="isGoogleLayerActive">
        <mat-icon>color_lens</mat-icon>
        <mat-slider
          min="-100"
          max="0"
          step="-1"
        >
          <input
            matSliderThumb
            [value]="layerSaturation"
            (input)="onSaturationLayerChange($event)"
          />
        </mat-slider>
      </div>
    </div>
  </mat-menu>

  <button mat-raised-button [matMenuTriggerFor]="aboveMenu" class="world-layer-btn">
    <!-- <mat-icon aria-hidden="false">map</mat-icon> -->
    <span class="px-2">{{ mapService.activeBaseLayer?.get(LAYER_KEY) }}</span>
    <mat-icon aria-hidden="false">arrow_drop_down</mat-icon>
  </button>

  <mat-menu #aboveMenu="matMenu" yPosition="above">
    <button *ngFor="let layer of worldLayersList" mat-menu-item (click)="changeWorldLayer(layer.id)" color="primary">
      <!-- <mat-icon aria-hidden="false">map</mat-icon> -->
      {{layer.label}}
    </button>
  </mat-menu>
</div>
